var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiCheckbox from '@material-ui/core/Checkbox';
import { makeStyles, useTheme } from '@material-ui/core/styles';
var useStyles = makeStyles(function (theme) { return ({
    icon: {
        width: 20,
        height: 20,
        border: "1px solid " + theme.palette.grey[800],
        borderRadius: 3,
        marginLeft: theme.spacing(1 / 4),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        'input:disabled ~ &': {
            border: "1px solid " + theme.palette.grey[400],
        },
    },
    checkedIcon: {
        width: 16,
        height: 16,
        borderRadius: 3,
    },
}); });
var Checkbox = function (_a) {
    var disabled = _a.disabled, color = _a.color, props = __rest(_a, ["disabled", "color"]);
    var classes = useStyles();
    var theme = useTheme();
    return (React.createElement(MuiCheckbox, __assign({ disabled: disabled, checkedIcon: color === 'primary' ? (React.createElement("span", { className: classes.icon },
            React.createElement("div", { style: {
                    backgroundColor: disabled ? theme.palette.grey[400] : theme.palette.primary.main,
                }, className: classes.checkedIcon }))) : (React.createElement("span", { className: classes.icon },
            React.createElement("div", { style: {
                    backgroundColor: disabled ? theme.palette.grey[400] : theme.palette.secondary.main,
                }, className: classes.checkedIcon }))), icon: React.createElement("span", { className: classes.icon }) }, props)));
};
Checkbox.defaultProps = {
    color: 'primary',
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map